import { das28 } from "./das28";
import { sdaiCdai } from "./sdai-cdai";
import { asdas } from "./asdas";
import { basdai } from "./basdai";
import { dapsa } from "./dapsa";
import { dapsa28 } from "./dapsa28";
import { essdai } from "./essdai";
import { esspri } from "./esspri";
import { vdi } from "./vdi";
import { bvas } from "./bvas";
import { ffs } from "./ffs";
import { sledai } from "./sledai";
import { ascvd } from "./ascvd";
import { frax } from "./frax";

// All calculators are implemented. To add a "coming soon" placeholder, push an
// object shaped `{ id, name, subtitle, group, status: "soon" }` — the list shows
// a badge and the runner stays disabled until a real definition replaces it.
export const CALCULATORS = [
    das28,
    sdaiCdai,
    asdas,
    basdai,
    dapsa,
    dapsa28,
    essdai,
    esspri,
    sledai,
    bvas,
    ffs,
    vdi,
    ascvd,
    frax,
];

export const getCalculatorById = (id) => CALCULATORS.find((c) => c.id === id);
